import { FC } from 'react';
import { useTheme } from 'styled-components/macro';

import Icon, { IconPropsT } from './Icon';

const TuneIcon: FC<IconPropsT> = props => {
  /**
   * Hooks
   */
  const theme = useTheme();

  return (
    <Icon {...props}>
      <svg
        height="20"
        width="20"
        viewBox="0 0 20 20"
        fill={theme.colors.primary.variant1}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M9.5 17v-5H11v1.75h6v1.5h-6V17ZM3 15.25v-1.5h5v1.5Zm3-2.75v-1.75H3v-1.5h3V7.5h1.5v5Zm3-1.75v-1.5h8v1.5ZM12 8V3h1.5v1.75H17v1.5h-3.5V8ZM3 6.25v-1.5h8v1.5Z" />
      </svg>
    </Icon>
  );
};

export default TuneIcon;
